import React, { useState, useEffect, useContext } from 'react'; // Import useContext here
import { useNavigate } from 'react-router-dom';


import { Route, Routes, Navigate, useLocation } from "react-router-dom";
import PerfectScrollbar from "perfect-scrollbar";

import AdminNavbar from "components/Navbars/AdminNavbar.js";
import Footer from "components/Footer/Footer.js";
import Sidebar from "components/Sidebar/Sidebar.js";

import routes from "routes.js";

import logo from "assets/img/logo.png";
import { BackgroundColorContext } from "contexts/BackgroundColorContext";

import { createTheme, ThemeProvider } from '@mui/material/styles';
import { Select, MenuItem } from '@mui/material';
import { prefix } from "../../siteConfig";

import { UserContext } from '../../index'; 
import { toast } from 'react-toastify';



const darkTheme = createTheme({
  palette: {
    mode: 'dark',
  },
  components: {
    MuiSelect: {
      styleOverrides: {
        root: {
          backgroundColor: '#424242',
          color: '#fff',
        },
      },
    },
  },
});


var ps;

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

function Admin( userExists, ...props) {
  const navigate = useNavigate();
  const location = useLocation();
  const mainPanelRef = React.useRef(null);
  const [sidebarOpened, setsidebarOpened] = React.useState(
    document.documentElement.className.indexOf("nav-open") !== -1
  );

  const userContext =  useContext(UserContext);
  const query = useQuery();
  const blind75optin = query.get('blind75optin');

  // React.useEffect(() => {
  //   if(!userContext.ctx.email){
  //     console.log("REDIRECTING")
  //     navigate('/')
  //   }
  // },[userContext])
  React.useEffect(() => {
    if (blind75optin) {
      // Perform your action here if "blind75optin" query parameter is present
      toast.success('Email Schedule will be added soon. You will receive your first email today or tomorrow', {
        autoClose: false
      });
      
    }
  }, [blind75optin]);

  React.useEffect(() => {
    if (navigator.platform.indexOf("Win") > -1) {
      document.documentElement.className += " perfect-scrollbar-on";
      document.documentElement.classList.remove("perfect-scrollbar-off");
      ps = new PerfectScrollbar(mainPanelRef.current, {
        suppressScrollX: true,
      });
      let tables = document.querySelectorAll(".table-responsive");
      for (let i = 0; i < tables.length; i++) {
        ps = new PerfectScrollbar(tables[i]);
      }
    }
    // Specify how to clean up after this effect:
    return function cleanup() {
      if (navigator.platform.indexOf("Win") > -1) {
        ps.destroy();
        document.documentElement.classList.add("perfect-scrollbar-off");
        document.documentElement.classList.remove("perfect-scrollbar-on");
      }
    };
  });
  React.useEffect(() => {
    if (navigator.platform.indexOf("Win") > -1) {
      let tables = document.querySelectorAll(".table-responsive");
      for (let i = 0; i < tables.length; i++) {
        ps = new PerfectScrollbar(tables[i]);
      }
    }
    document.documentElement.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
    if (mainPanelRef.current) {
      mainPanelRef.current.scrollTop = 0;
    }
  }, [location]);
  // this function opens and closes the sidebar on small devices
  const toggleSidebar = () => {
    document.documentElement.classList.toggle("nav-open");
    setsidebarOpened(!sidebarOpened);
  };
  const getRoutes = (routes) => {
    return routes.map((prop, key) => {
      if (prop.layout === "/admin") {
        return (
          <Route path={prop.path} element={prop.component} key={key} exact />
        );
      } else {
        return null;
      }
    });
  };
  const getBrandText = (path) => {
    return "Learn Leet Code";
  };
  return (
    <ThemeProvider theme={darkTheme}>
    <BackgroundColorContext.Consumer>
      {({ color, changeColor }) => (
        <React.Fragment>
          <div className="wrapper">
            <Sidebar
              routes={routes}
              logo={{
                outterLink: "https://www.learnleetcode.com",
                text: "Learn Leet Code",
                imgSrc: logo,
              }}
              toggleSidebar={toggleSidebar}
            />
            <div className="main-panel" style={{ borderTop: 0 }} ref={mainPanelRef} data={color}>
              <AdminNavbar
                brandText={getBrandText(location.pathname)}
                toggleSidebar={toggleSidebar}
                sidebarOpened={sidebarOpened}
              />
              <Routes>
                {getRoutes(routes)}
                <Route
                  path="/login"
                  element={<Navigate to="/login" replace />}
                />
                <Route
                  path="/*"
                  element={<Navigate to="/admin/learn" replace />}
                />
              </Routes>
              {
                // we don't want the Footer to be rendered on map page
                location.pathname === "/admin/maps" ? null : <Footer fluid />
              }
            </div>
          </div>
        </React.Fragment>
      )}
    </BackgroundColorContext.Consumer>
    </ThemeProvider>
  );
}

export default Admin;